module.exports = __webpack_public_path__ + "assets/img/baidilogo.da664a83.png";